import { OwnerInvite, toInvite } from './inviteStore';
import { isFirebaseConfigured } from '../auth/config';

let firestorePromise: Promise<import('firebase/firestore').Firestore | null> | null = null;

const loadFirestore = async () => {
    if (!isFirebaseConfigured()) {
        return null;
    }

    if (!firestorePromise) {
        firestorePromise = (async () => {
            try {
                const { getApp, getApps, initializeApp } = await import('firebase/app');
                const { getFirestore } = await import('firebase/firestore');
                const app = getApps().length > 0
                    ? getApp()
                    : initializeApp({
                          apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
                          authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
                          projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
                          appId: process.env.REACT_APP_FIREBASE_APP_ID,
                      });
                return getFirestore(app);
            } catch (error) {
                console.error('Firestore failed to initialize', error);
                return null;
            }
        })();
    }

    return firestorePromise;
};

export const fetchInviteByEmail = async (
    email: string | null | undefined
): Promise<OwnerInvite | null> => {
    const normalized = (email || '').trim().toLowerCase();
    if (!normalized) {
        return null;
    }

    const db = await loadFirestore();
    if (!db) {
        return null;
    }

    const { doc, getDoc } = await import('firebase/firestore');
    try {
        const snap = await getDoc(doc(db, 'invites', normalized));
        if (!snap.exists()) {
            return null;
        }
        return toInvite({ id: snap.id, ...(snap.data() as Partial<OwnerInvite>) });
    } catch (error) {
        const code = error && typeof error === 'object' && 'code' in error
            ? String((error as { code?: string }).code)
            : '';
        if (code === 'permission-denied') {
            return null;
        }
        throw error;
    }
};
